import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {o, OdataQuery} from "odata";
import {FilterComponent} from "../filter/filter.component";
import {FilterSettings, FilterOption, FilterUtils} from "../filter";

@Component({
    selector: 'string-filter',
    templateUrl: './string-filter.component.html',
})
export class StringFilterComponent extends FilterComponent implements AfterViewInit {
    
    public Options: FilterOption[] = [
        {
            Name: 'Contains',
            FilterClauseFormat: 'contains(tolower({{0}}), tolower(\'{1}\'))'
        },
        {
            Name: 'Equals',
            FilterClauseFormat: 'tolower({{0}}) eq tolower(\'{1}\')'
        },
        {
            Name: 'Does Not Equal',
            FilterClauseFormat: 'tolower({{0}}) ne tolower(\'{1}\')'
        },
        {
            Name: 'Starts With',
            FilterClauseFormat: 'startswith(tolower({{0}}), tolower(\'{1}\'))'
        },
        {
            Name: 'Ends With',
            FilterClauseFormat: 'endswith(tolower({{0}}), tolower(\'{1}\'))'
        }
    ];
    
    public SelectedOption: FilterOption;
    
    public Value: string;

    @ViewChild('filterInput')
    public FilterInput: ElementRef<HTMLInputElement>;
    
    constructor() {
        super();
    }
    
    ngOnInit() {
        if (this.FilterSettings) {
            this.SelectedOption = this.FilterSettings.FilterModel.Option;
            this.Value = this.FilterSettings.FilterModel.Value;
        }
        else {
            this.SelectedOption = this.Options[0];
        }
    }
    
    ngAfterViewInit() {
        if (this.Autofocus) {
            setTimeout(() => {
                this.FilterInput.nativeElement.focus();
            }, 50);
        }
    }

    updateFilterSettings() {
        this.FilterSettingsChange.emit(new FilterSettings(
            FilterUtils.format(
                this.SelectedOption.FilterClauseFormat,
                '0',
                this.Value ? this.Value.replace("'", "''") : ''),
            {
                Option: this.SelectedOption,
                Value: this.Value
            }
        ));
    }
}
